import React, { useState, useEffect, useRef } from 'react';
import './landing-course-card.css';
import BadgeBasic from "../badges/BadgeBasic";
import CTAButton from "../cta-button/CTAButton";
import SideImage from "../side-image/SideImage";

const LandingCourseCard = ({ courseCost, discountType, discountAmount, courseCostClass, courseTitle, courseDescription, courseLength, badgeContent, badgeIcon, ctaBtnContent, ctaBtnIcon, imgSrc, imgAltText }) => {
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const descriptionRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (descriptionRef.current) {
                setIsOverflowing(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
            }
        };

        // Check on initial mount and when description changes
        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [courseDescription]);

    const toggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    };

    const discount = discountType && discountType === 'percent' ?
        parseFloat(courseCost) * (parseFloat(discountAmount) / 100) :
        discountType === 'amount' ?
            parseFloat(courseCost) - parseFloat(discountAmount) :
            null;

    const discountedCost = discount ?
        parseFloat(courseCost) - discount :
        courseCost;

    return (
        <div className='card-landing-course'>
            <div className='card-landing-course-thumbnail'>
                <SideImage
                    imgSrc={imgSrc}
                    altText={imgAltText}
                />
                <div className='wrapper-course-cost'>
                    {
                        courseCost === discountedCost ?
                            <h4 className={courseCostClass}>
                                ${courseCost}
                            </h4> :
                            <>
                                <h4 className={`${courseCostClass} strike-through text-shrink-md`}>
                                    ${courseCost}
                                </h4>
                                <h4 className={`text-orange`}>
                                    ${discountedCost}
                                </h4>
                            </>
                    }
                </div>
            </div>
            <div className='card-landing-course-difficulty'>
                <p className='course-time'>
                    {courseLength}
                </p>
                <BadgeBasic
                    className='badge badge-blue'
                    content={badgeContent}
                    icon={badgeIcon}
                />
            </div>
            <div className='card-landing-course-content'>
                <h3 className='title-sub-3 text-gradient-orange'>
                    {courseTitle}
                </h3>
                <p className={`paragraph-dk-sub course-description ${showFullDescription ? '' : 'short-description'}`} ref={descriptionRef}>
                    {courseDescription}
                </p>
                <h6 onClick={toggleDescription} className={`show-more-btn ${isOverflowing ? 'text-gradient-orange' : 'hide show-more-btn-hide'}`}>
                    {showFullDescription ? 'SHOW LESS...' : 'SHOW MORE...'}
                </h6>
            </div>
            <div className='card-landing-course-purchase'>
                <CTAButton
                    url='/#landing-courses'
                    icon={ctaBtnIcon}
                    className='card-btn btn-cta-sub text-lt bg-slanted-gradient-purple'
                    content={ctaBtnContent} />
            </div>
        </div>
    );
}

export default LandingCourseCard;
